export default ({ $config }) => {
  return [
    {
      value: "name",
      text: "Name",
      width: 150,
      sortable: true,
    },
    {
      value: "status",
      text: "Status",
      width: 85,
    },
    {
      value: "archiveTier",
      text: "Archive Tier",
      width: 85,
      sortable: true,
    },
    {
      value: "exid",
      text: "Project ID",
      width: 100,
      sortable: true,
    },
    {
      value: "zohoId",
      text: "Zoho",
      sortable: false,
      width: 60,
      align: "center",
      toStringFn: (item, key) =>
        item[key]
          ? `${$config.public.zohoCrmUrl}/tab/CustomModule12/${item[key]}`
          : "-",
    },
    {
      value: "demo",
      text: "Demo",
      sortable: false,
      width: 40,
      align: "center",
    },
    {
      value: "startDate",
      text: "Start Date",
      width: 120,
      sortable: true,
    },
    {
      value: "endDate",
      text: "End Date",
      width: 120,
      sortable: true,
    },
    {
      value: "timezone",
      text: "Timezone",
      sortable: true,
      width: 136,
    },
    {
      value: "cameras",
      text: "Cameras",
      width: 150,
      sortable: false,
      sort: (a, b) => {
        return a.length > b.length ? 1 : -1
      },
      toStringFn: (item, key) =>
        item[key]?.map((camera) => camera.name).join(",") || "-",
    },
    {
      value: "featureFlags",
      text: "Feature Flags",
      sortable: true,
      width: 200,
    },
    {
      value: "insertedAt",
      text: "Created At",
      width: 150,
      sortable: true,
    },
  ]
}
